<template>
  <b>Последняя активность:</b>&nbsp;&nbsp;
  <span title="PPPoE" v-if="dclient.ppp"><Icon name="link" /> {{common.formatLocalTime(dclient.ppp.time)}}</span>&nbsp;
  <span title="IPoE" v-if="dclient.ipoe"><Icon name="fa-plug" /> {{common.formatLocalTime(dclient.ipoe.time)}}</span>&nbsp;
  <span title="Телеграм-бот" v-if="dclient.abonbot"><Icon name="brand-telegram" /> {{common.formatLocalTime(dclient.abonbot.time)}}</span>&nbsp;
  <span title="Кабинет" v-if="dhistory.cabinet"><Icon name="fa-archive" /> {{common.formatLocalTime(dhistory.cabinet.time)}} ({{dhistory.cabinet.ip}})</span>&nbsp;
  <span title="Приложение" v-if="dhistory.mobile"><Icon name="brand-android" /> {{common.formatLocalTime(dhistory.mobile.time)}} ({{dhistory.mobile.ip}})</span>
</template>

<script>
import darsan from "darsan"
import sysconf from "sysconf"

export default {

  name: "LastActivity",
  
  props: {
    state: Object,
  },
  
  data()
  {
    return {
      dhistory: {},
      dclient: {},
    }
  },
  
  methods: {
    async loadData()
    {
      const uid = this.state.uid
      if (!uid) return
      const prefix = sysconf.domainByUid(uid) || config.domain
      
      const [dhistory, dclient] = await Promise.all([
        darsan.get(prefix, "history", `/client/${uid}/last-activity`),
        darsan.get(prefix, "client", `/client/${uid}/last-activity`),
      ])
      
      this.dhistory = dhistory
      this.dclient = dclient
    },
  },
  
  watch: {
    "state.uid": {
      handler(val)
      {
        this.loadData()
      },
      immediate: true,
    },
  },
}
</script>

